import { Link } from "react-router-dom";
import MainBanner from "../../../Assets/Images/MainBanner.jpg";

export default function HomeMain() {
  const handleClick = (path, targetId) => {
    // Ensure we're on the correct route
    if (path === window.location.pathname) {
      // Scroll to the target element if it exists
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <div className="main">
        <img src={MainBanner} alt="Glavna slika" />
        <div className="main-bio">
          <h1>Vaša sljedeća oaza mira</h1>
          <h5>
            Koliba <span>"Lika"</span>
          </h5>
          <div>
            <Link
              className="down-btn"
              to="/"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link navigation
                handleClick("/", "#home-about");
              }}
            >
              <i className="fi fi-ss-chevron-double-down"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
